import { defineMessages } from "react-intl";

import { Role } from "@mapmycustomers/shared";

import { groupsTour } from "@app/component/flows/GettingStarted/adminsGroupsTour";
import ChecklistDescriptor from "@app/component/flows/types/ChecklistDescriptor";

import { managersDataBasicsTour, ownersDataBasicsTour } from "./adminsDataBasicsTour";
import { managersInitialSetupTour, ownersInitialSetupTour } from "./adminsInitialSetupTour";
import { adminsReportingTour } from "./adminsReportingTour";
import { repsInitialSetupTour } from "./repsInitialSetupTour";
import { repsPerformanceTour } from "./repsPerformanceTracking";
import { repsWebAppBasicsTour } from "./repsWebAppBasicsTour";

const messages = defineMessages({
  dataBasics: {
    id: "guides.gettingStarted.checklist.dataBasics",
    defaultMessage: "Data Basics",
  },
  description: {
    id: "guides.gettingStarted.checklist.description",
    defaultMessage:
      "This guide will show you the basics you need to use Map My Customers like a pro, custom to each role.",
  },
  groups: {
    id: "guides.gettingStarted.checklist.groups",
    defaultMessage: "Groups",
  },
  initialSetup: {
    id: "guides.gettingStarted.checklist.initialSetup",
    defaultMessage: "Initial Setup",
  },
  performance: {
    id: "guides.gettingStarted.checklist.performance",
    defaultMessage: "Performance Tracking",
  },
  reporting: {
    id: "guides.gettingStarted.checklist.reporting",
    defaultMessage: "Reporting Overview",
  },
  title: {
    id: "guides.gettingStarted.checklist",
    defaultMessage: "Getting started",
  },
  webAppBasics: {
    id: "guides.gettingStarted.checklist.webAppBasics",
    defaultMessage: "Web App Basics",
  },
});

export const gettingStartedChecklistConfiguration: ChecklistDescriptor = {
  id: "mmc-getting-started",
  steps: [
    // for admins:
    {
      id: "initial-setup-owners",
      eligibleRoles: [Role.OWNER],
      path: "/settings",
      title: messages.initialSetup,
      tour: ownersInitialSetupTour,
    },
    {
      id: "initial-setup-managers",
      eligibleRoles: [Role.MANAGER],
      path: "/settings",
      title: messages.initialSetup,
      tour: managersInitialSetupTour,
    },
    {
      id: "data-basics-owners",
      eligibleRoles: [Role.OWNER],
      path: "/settings/data/new-import",
      title: messages.dataBasics,
      tour: ownersDataBasicsTour,
    },
    {
      id: "data-basics-manages",
      eligibleRoles: [Role.MANAGER],
      path: "/map",
      title: messages.dataBasics,
      tour: managersDataBasicsTour,
    },
    {
      id: "reporting",
      eligibleRoles: [Role.OWNER, Role.MANAGER],
      path: "/dashboard",
      title: messages.reporting,
      tour: adminsReportingTour,
    },
    {
      id: "group-creation",
      eligibleRoles: [Role.OWNER, Role.MANAGER],
      path: "/map",
      title: messages.groups,
      tour: groupsTour,
    },
    // for reps:
    {
      id: "initial-setup-rep",
      eligibleRoles: [Role.MEMBER, Role.READ_ONLY, Role.READ_ONLY_WITH_EXPORTS],
      path: "/settings/personal/calendar-sync",
      title: messages.initialSetup,
      tour: repsInitialSetupTour,
    },
    {
      id: "web-app-basics",
      eligibleRoles: [Role.MEMBER, Role.READ_ONLY, Role.READ_ONLY_WITH_EXPORTS],
      path: "/company",
      title: messages.webAppBasics,
      tour: repsWebAppBasicsTour,
    },
    {
      id: "performance-tracking",
      eligibleRoles: [Role.MEMBER, Role.READ_ONLY, Role.READ_ONLY_WITH_EXPORTS],
      path: "/dashboard",
      title: messages.performance,
      tour: repsPerformanceTour,
    },
  ],
  subTitle: messages.description,
  title: messages.title,
};
